@import '../../../../utils/global.module.less';

.modified_data {
    animation-delay: calc(var(--grid-column) * 0.05s) !important;
}

.dollar {
    * > {
        color: @editable-text-color !important;
    }
}
.editable {
    color: @editable-text-color !important;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.3s;
    border-radius: 10px;

    &:hover {
        background-color: #f2f4f7;
    }
    &:active {
        background-color: #d9d9d9;
    }
}

.editHandIcon {
    color: #2075f4;
    height: 35px;
    width: 38px;
}

.rowLabel {
    color: #102442;
    font-family: Hanken Grotesk;
    div[class*='title'] {
        font-weight: bold;
        font-size: 16px;
    }

    div[class*='desc'] {
        font-size: 13px;
    }
}

.columnHeader {
    color: #667085;
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: bold;
}
.rowValue {
    width: 100%;
    color: #102442;
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: bold;
}

.rowValueBoolean {
    font-size: 32px;
    color: #102442;
}

.source_page_entry {
    min-width: 40px;
    background-color: #f2f4f7;
    color: #2075f4;
    font-size: 16px;
    font-weight: 500;
    padding: 5px 10px;
    border-radius: 25px;
    text-align: center;
    transition: background-color 0.3s;
    cursor: pointer;
    user-select: none;
    margin: 5px 3px;
    height: 38px;
    &:hover {
        background-color: #d9d9d9 !important;
    }
    &:active {
        background-color: #b3b3b3 !important;
    }
}
